import { render, staticRenderFns } from "./BsiContinuousFilingFiles.vue?vue&type=template&id=7585df39&scoped=true&"
import script from "./BsiContinuousFilingFiles.vue?vue&type=script&lang=js&"
export * from "./BsiContinuousFilingFiles.vue?vue&type=script&lang=js&"
import style0 from "./BsiContinuousFilingFiles.vue?vue&type=style&index=0&id=7585df39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7585df39",
  null
  
)

export default component.exports